import { EPlatform, getClient } from '@/api/app';

/**
 * 全局配置
 */

import featureList from './features';
const isProduction = process.env.NODE_ENV === 'production' && process.env.CLOUD_ENV === 'production';
const isTest = process.env.CLOUD_ENV === 'test';
const isDev = process.env.CLOUD_ENV === 'develop';
const timeStamp = process.env.TIME_STAMP!;

/**
 * 判断当前客户端
 */
const client = getClient();
const platform = [EPlatform.IOS, EPlatform.Android, EPlatform.RN].includes( client ) ? 'app' : 'web';
const oem = 'snapeak';
const reolinkPhone = '533046668';
let reolink: string;
let accountCenter: string;
let api: string;
let envFlag = '';
let officialStore: string;
let cloudConfig: string;
let cookieDomain: string;
let secretDomain: string;
let clientId: string;
let originUrl: string;
let cdn1: string;
let cdn2: string;

// Mon Apr 10 2023 15:00:00 GMT+0800 (中国标准时间)
const basicPlanVersionTime = 1681110000000;

if ( isProduction ) {

    envFlag = 'production';
    reolink = 'https://camovue.com';
    accountCenter = 'https://my.camovue.com';
    api = 'https://apis.camovue.com';
    officialStore = 'https://camovue.com';
    cloudConfig = 'cloud-config';
    cookieDomain = '.camovue.com';
    secretDomain = 'cloud.camovue.com';
    clientId = 'CKyVp0WLGe5IAuqmIb5u48bYUVYwJdx0';
    originUrl = 'https://cloud.camovue.com';
    cdn1 = 'https://a.camovue-static.com';
    cdn2 = 'https://b.camovue-static.com';

} else if ( isTest ) {

    envFlag = 'sandbox';
    reolink = 'https://review.reolink.me';
    accountCenter = 'https://my.review.reolink.me';
    api = 'https://apis.review.reolink.me';
    officialStore = 'https://review.reolink.me';
    cloudConfig = 'cloud-config-test';
    cookieDomain = '.review.reolink.me';
    secretDomain = 'cloud.review.reolink.me';
    clientId = 'CKcJKdwLBsLnvOHipGBeKFYC4CAmkzqe';
    originUrl = 'https://cloud.review.reolink.me';
    cdn1 = 'https://cdn-a.review.reolink.me';
    cdn2 = 'https://cdn-b.review.reolink.me';

} else if ( isDev ) {

    envFlag = 'develop';
    reolink = 'https://dev.reolink.me';
    accountCenter = 'https://my.dev.reolink.me';
    api = 'https://apis.dev.reolink.me';
    officialStore = 'https://dev.reolink.me';
    cloudConfig = 'cloud-config-dev';
    cookieDomain = '.dev.reolink.me';
    secretDomain = 'cloud.dev.reolink.me';
    clientId = 'CK7msy2PY9fXy2NZrYRfz4nITPiwpgvS';
    originUrl = 'https://cloud.dev.reolink.me';
    cdn1 = 'https://cdn-a.dev.reolink.me';
    cdn2 = 'https://cdn-b.dev.reolink.me';

} else {

    envFlag = 'develop';
    reolink = 'https://dev.reolink.me';
    accountCenter = 'https://my.dev.reolink.me';
    api = 'https://apis.dev.reolink.me';
    officialStore = 'https://dev.reolink.me';
    cloudConfig = 'cloud-config-dev';
    cookieDomain = '.dev.reolink.me';
    secretDomain = 'cloud.dev.reolink.me';
    clientId = 'CK7msy2PY9fXy2NZrYRfz4nITPiwpgvS';
    originUrl = 'https://cloud.dev.reolink.me';
    cdn1 = 'https://cdn-a.dev.reolink.me';
    cdn2 = 'https://cdn-b.dev.reolink.me';

}

const envFlagString = envFlag === '' ? '' : envFlag + '.';
const version = 'v2';
export const config = {
    // 是否开启debuger模式
    isDebug: false,
    envFlag: envFlag,
    envFlagString: envFlagString,
    reolinkPhone,
    // 语言
    lang: 'en',
    langList: [
        'en',
        // 'de',
        // 'fr',
        // 'es'
        // 'it'
        // 'jp'
    ],
    isProduction,
    // 版本号 v1.0 || v9.9
    version: version,
    // url请求头
    // urlHead: `${api}/${this.version}`,
    reolink: reolink,
    baseUrl: `${api}/`,
    cloudVideoPageUnit: 40,
    accountCenterLoginUrl: `${accountCenter}/login`,
    accountCenterSignupUrl: `${accountCenter}/login#signup`,
    accountCenterProfileUrl: `${accountCenter}/`,
    accountCenterSecurityUrl: `${accountCenter}/#account`,
    accountCenterLogoutUrl: `${accountCenter}/logout`,
    accountCenterTotpUrl: `${accountCenter}/?open=totp&current=security`,
    accountCenterE2EEManagerUrl: `${accountCenter}/?current=security&open=protection`,
    accountCenterResetPinUrl: `${accountCenter}/?current=security&open=protection&method=resetCode`,
    client: client,
    defaultAvatar: `https://a.camovue-static.com/user/avatars/default-avatar.png?sv=${timeStamp}`,
    feature: featureList,
    signipRedirect: `${accountCenter}/login?redirect=${window.location.origin}/user/cloud-library/#signup`,
    contact_us: 'https://reolink.com/contact-us/',
    conditions: `https://reolink.com/terms-conditions/`,
    privacy: `https://reolink.com/privacy-policy/`,

    // ! todo app_store: 'https://itunes.apple.com/us/app/reolink/id995927563?ls=1&mt=8',
    // ! todo google_play: 'https://play.google.com/store/apps/details?id=com.mcu.reolink',
    app_store: originUrl,
    google_play: originUrl,

    about_us: `${reolink}/about-us/`,
    support_email: 'support@reolink.com',
    logo: `https://home-cdn.reolink.us/wp-content/uploads/2017/02/reolink-logo.png?sv=${timeStamp}`,
    platform: platform,

    support_team: 'https://support.camovue.com/hc/en-us/requests/new',
    support_cloud_url: 'https://support.camovue.com/hc/en-us',
    support_change_card: 'https://support.camovue.com/hc/en-us',

    support_view_url: 'https://support.reolink.com/hc/en-us/articles/13200357180441',
    support_video_protection_promote_url: 'https://support.reolink.com/hc/en-us/articles/18208181849241/',
    support_video_how_to_protection_url: 'https://support.reolink.com/hc/en-us/articles/18210730725145/',
    support_video_protection_explain: 'https://support.reolink.com/hc/en-us/articles/18210730725145/',
    basic_plan_title: 'Basic Plan',
    s3Config: `https://home-cdn.reolink.us/wp-content/uploads/2018/public/${cloudConfig}.json?sv=${timeStamp}`,
    officialStore: officialStore,
    // ! todo totpFaq: `https://support.camovue.com/hc/en-us/articles/7362536940569`,
    totpFaq: originUrl,
    cookieDomain: cookieDomain,
    // ! todo downloadCenter: 'https://camovue.com/software-and-manual/',
    downloadCenter: originUrl,

    plan_disabled_support: 'https://support.reolink.com/hc/en-us/articles/9604648154009',
    legacy_plan_support: 'https://support.reolink.com/hc/en-us/articles/17770178751385-Introduction-to-Legacy-Cloud-Plan/',
    how_to_use_traffic: 'https://support.reolink.com/hc/en-us/articles/13200357180441-Introduction-to-Reolink-View-Service-Beta-/#h_01GKJQ08115BA53VAZZXBSMTCC',
    user_guide_traffic: 'https://support.reolink.com/hc/en-us/articles/13200357180441/',
    secretDomain,
    oem,
    basicPlanVersionTime,
    clientId,
    originUrl,
    accountCenter,
    urlHead: `${api}/${version}`,
    /** 仅限 Web 资源使用，如 js/css/图片/html/json/pem/字体 */
    cdn1,
    /** 仅限视频、压缩包等资源使用 */
    cdn2,
    componentPathPrefix: '@/view'
};

export const setConfig = ( key: string, value: string ): void => {

    config[ key ] = value;

};
